import React, { useState, useEffect } from "react";
import * as ruleService from "../../../ruleService";
import { deepCopy, sortByAlphabet } from "../../../../utils";
import SelectV2 from "../../../../view/SelectV2";
import { isMsbForDeviceType } from "../../msbFilter";

function SelectMsbField({ selectedType, setMsbId, msbId }) {
    const [msbList, setMsbList] = useState([]);

    useEffect(() => {
        const loadMsbList = async () => {
            const list = await ruleService.msbList();
            if (list && Array.isArray(list) && list.length) {
                setMsbList(list);
            }
        }
        loadMsbList();
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [])


    const onChange = (id) => {
        setMsbId(id === "-1" ? undefined : id);
    };

    const msbRenderList = deepCopy(msbList)
        .filter(msb => isMsbForDeviceType(msb, selectedType))
        .sort((a, b) => sortByAlphabet(a.name, b.name));

    const options = [
        { value: "-1", label: "Choose" },
        ...((msbRenderList || []).map((msb) => ({
            value: String(msb.id),
            label: msb.name
        })))
    ];

    return (
        <div className="target-type-wizard-field">
            <label htmlFor="msb" className="target-type-wizard-field__label">Refer MSB</label>
            <SelectV2
                inputId="msb"
                className="target-type-wizard-select"
                value={String(msbId ?? "-1")}
                onChange={onChange}
                options={options}
                isDisabled={!selectedType || String(selectedType) === "-1"}
                noOptionsMessage={() => "No MSBs available"}
            />
        </div>
    );

}

export default SelectMsbField;
